import { frontendURL, conversationUrl } from 'dashboard/helper/URLHelper';

const MIN_GROUP_MEMBERS = 3;

export function isInternalConversation(conversation) {
  return Boolean(
    conversation?.meta?.internal_conversation ||
      conversation?.additional_attributes?.internal_conversation
  );
}

export function isInternalGroupConversation(conversation) {
  return (
    conversation?.meta?.internal_group ||
    conversation?.additional_attributes?.internal_conversation_type === 'group'
  );
}

export function internalParticipantIds(conversation) {
  const ids = conversation?.additional_attributes?.internal_participant_ids;
  if (Array.isArray(ids) && ids.length) return ids.map(id => Number(id));

  const fromMeta = conversation?.meta?.internal_participants;
  if (fromMeta?.length) return fromMeta.map(member => member.id);

  return [];
}

export function isUserInternalParticipant(conversation, userId) {
  if (!userId) return false;

  return internalParticipantIds(conversation).includes(Number(userId));
}

export function shouldIncludeInternalConversationInList(conversation, userId) {
  if (!isInternalConversation(conversation)) return true;

  return isUserInternalParticipant(conversation, userId);
}

export function canRemoveInternalGroupMembers(conversation) {
  return internalParticipantIds(conversation).length > MIN_GROUP_MEMBERS;
}

export function handleInternalGroupMembershipChange(store, router, conversation) {
  if (!isInternalConversation(conversation)) return;

  const currentUserId = store.getters.getCurrentUser?.id;

  if (shouldIncludeInternalConversationInList(conversation, currentUserId)) {
    return;
  }

  store.commit('DELETE_CONVERSATION', conversation.id);
  store.dispatch('clearSelectedState');

  const inboxId = conversation.inbox_id;
  const accountId = store.getters.getCurrentAccountId;
  const path = frontendURL(
    conversationUrl({
      accountId,
      activeInbox: inboxId,
    })
  );

  if (router?.currentRoute?.value?.params?.conversation_id) {
    router.push({ path });
  }
}
